class BarraFreteGratisUpdater {
  constructor() {
    this.updateBarras = this.updateBarras.bind(this);
    window.addEventListener("cart:updated", this.updateBarras);
    this.updateBarras();
  }

  async updateBarras() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`);
      const text = await response.text();
      const dom = new DOMParser().parseFromString(text, "text/html");

      this.updateElement(".freteGratis", dom);
      this.updateElement(".freteGratis2", dom);
    } catch (error) {
      console.error("[BarraFreteGratisUpdater] Erro ao atualizar barras:", error);
    }
  }

  updateElement(selector, dom) {
    const newEl = dom.querySelector(selector);
    const currentEl = document.querySelector(selector);
    if (newEl && currentEl) {
      currentEl.innerHTML = newEl.innerHTML;
      console.log(`[BarraFreteGratisUpdater] Atualizado: ${selector}`);
    } else {
      console.warn(`[BarraFreteGratisUpdater] ${selector} não encontrado no DOM ou na resposta.`);
    }
  }
}

// Instância única ao carregar a página
document.addEventListener("DOMContentLoaded", () => {
  window.barraFreteUpdater = new BarraFreteGratisUpdater();
});
